import VerifyOutCashSales from "../../../../components/@documents/cash_sales/VerifyOutCashSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CashSalesVerifyOutPage() {

    return (
        <VerifyOutCashSales 
            routeType={routeTypes.workstation}
        />
    )
}